module.exports = __webpack_public_path__ + "img/可视化数据大屏系统.84aa250d.png";